export const APP_CONFIG = {
  name: 'JAMS',
  redirectWaitTime: 4000,
}
